import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { Observable } from 'rxjs'
import { NavigationService } from '../services/navigation/navigation.service'
import { Preferences } from '@capacitor/preferences'
import { StorageService } from '../services/storage/storage.service'

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard implements CanActivate {
  constructor(
    private storage: StorageService,
    private navigation: NavigationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise<boolean>((resolve) => {
      setTimeout(async () => {
        const { value } = await Preferences.get({ key: 'profile' })
        const profile = value ? JSON.parse(value) : undefined

        if (!profile) {
          this.storage.removeSession()
          this.navigation.toLoginPage()
          resolve(false)
          return
        }

        // const phoneVerified =
        //   profile?.phone_verified || profile?.whatsapp_verified
        // const emailVerified = profile?.email_verified

        // if (!phoneVerified || !emailVerified) {
        //   this.navigation.toAccountVerifyPage()
        //   resolve(false)
        //   return
        // }

        if (profile.role_type === 29) {
          if (state.url !== '/pengajuan') {
            this.navigation.toPengajuanPage()
            resolve(false)
          }
          if (state.url === '/pengajuan') {
            resolve(true)
          }
          return
        }

        resolve(true)
      }, 150)
    })
  }
}
